export enum ETabs {
  Settlement = 'settlement',
  Status = 'status',
  Void = 'void',
}

export type TTabButton = { text: string; option: ETabs; onClick: () => void };
